/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Collapse, Grid2, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    Apartment,
    Flag,
    KeyboardArrowDown,
    KeyboardArrowUp,
    LocalShippingOutlined,
    PhoneAndroidOutlined,
    PlaceOutlined, QrCode2,
    StorefrontOutlined,
    WarehouseOutlined
} from "@mui/icons-material";
import IngresoTextoBarraBusqueda from "../../Modulo_formularios/Componentes/IngresoTextoBarraBusqueda";
import {buscarPalabra} from "../../Modulo_Algolia/Funciones/buscarPalabra";
import Tarjeta_Cliente from "../Tarjetas/Tarjeta_Cliente";
import {useState} from "react";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";

const Formulario_Despacho = ({...props}) => {
    const [ver, setVer] = useState(false)

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos del Cliente</Typography>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTextoBarraBusqueda ejemplo={'Nombre, Razon Social, Nit'} Icono={AccountCircleOutlined}
                                               nombre={'Nombre'}
                                               dato={'nombre'} {...props} funcionBuscar={buscarPalabra}
                                               nombreIndex={'clientes'}
                                               Tarjeta={Tarjeta_Cliente}
                                               requerido={'El Nombre es requerido'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={StorefrontOutlined} nombre={'Razon Social'} dato={'razon'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6}}>
                    <Typography sx={{fontSize: 14}}>Datos de ubicacion</Typography>
                </Grid2>

                <Grid2 container size={{xs: 6}} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => setVer(!ver)}
                        endIcon={ver ? <KeyboardArrowUp/> : <KeyboardArrowDown/>} sx={{px: 0, py: 0}}
                        variant={'text'}>{ver ? 'Ver menos' : 'Ver mas'}</Button>
                </Grid2>

                <Collapse in={ver} sx={{width: '100%'}}>

                    <Grid2
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        spacing={2}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                            <IngresoTexto Icono={Flag} nombre={'Departamento'} dato={'departamento'} {...props}
                            />
                        </Grid2>

                        <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                            <IngresoTexto Icono={Apartment} nombre={'Ciudad'} dato={'ciudad'} {...props}
                            />
                        </Grid2>

                        <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                            <IngresoTexto Icono={StorefrontOutlined} nombre={'Direccion'} dato={'direccion'} {...props}
                            />
                        </Grid2>

                        <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                            <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular 1'}
                                          dato={'celularUno'} {...props}
                                          type={'phone'}
                            />
                        </Grid2>

                        <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                            <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular 2'}
                                          dato={'celularDos'} {...props}
                                          type={'phone'}
                            />
                        </Grid2>

                        <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                            <Typography sx={{fontSize: 14}}>Datos geograficos</Typography>
                        </Grid2>

                        <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                            <IngresoTexto Icono={PlaceOutlined} nombre={'Latitud'} dato={'latitud'} {...props}
                                          type={'number'}
                            />
                        </Grid2>

                        <Grid2 container size={{xs: 6, sm: 6, md: 6}}>
                            <IngresoTexto Icono={PlaceOutlined} nombre={'Longitud'} dato={'longitud'} {...props}
                                          type={'number'}
                            />
                        </Grid2>

                    </Grid2>
                </Collapse>

                <Grid2 container size={{xs: 12}} sx={{marginTop: ver ? 0 : -2}}>
                    <Typography sx={{fontSize: 14}}>Datos de despacho</Typography>
                </Grid2>

                <Grid2 container size={{xs: 12}}>
                    <IngresoTexto Icono={QrCode2} nombre={'Identficador'}
                                  dato={'identificador'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6}}>
                    <IngresoFecha Icono={LocalShippingOutlined} nombre={'Fecha de Salida'}
                                  dato={'fechaSalida'} {...props}
                    />
                </Grid2>

                <Grid2 container size={{xs: 6}}>
                    <IngresoFecha Icono={WarehouseOutlined} nombre={'Fecha de Llegada'} dato={'fechaLlegada'} {...props}
                    />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Despacho